<script>
import Service from '@/src/services/itens_produto'

const labels = {
  id_item_produto: 'Identificador da relação existente',
  memorizar: 'Aprendizado de equivalências',
  produto: 'Produto',
  cultura: 'Cultura',
  alvo: 'Alvo',
  praga: 'Alvo',
  unidade_dose: 'Unidade da dose',
  unidade_calda: 'Unidade da calda',
  tipo_aplicacao: 'Tipo de aplicação',
  local_aplicacao: 'Local de aplicação',
  estagio_alvo: 'Estágio do alvo',
  estagio_cultura: 'Estágio da cultura',
  dose_min: 'Dose mínima',
  dose_max: 'Dose máxima',
  volume_calda_min: 'Volume de calda mínimo',
  volume_calda: 'Volume de calda máximo',
  numero_aplicacoes_min: 'Número mínimo de aplicações',
  numero_aplicacoes_max: 'Número máximo de aplicações',
  intervalo_seguranca: 'Intervalo de segurança',
}
const memoryFields = [
  'cultura',
  'alvo',
  'tipo_aplicacao',
  'unidade_dose',
  'unidade_calda',
  'local_aplicacao',
  'estagio_alvo',
  'estagio_cultura',
]
const memoryScopes = [
  { value: '', text: 'Automático — recomendado' },
  { value: 'empresa', text: 'Nesta empresa' },
  { value: 'produto', text: 'Neste produto' },
  { value: 'cultura', text: 'Nesta cultura' },
  { value: 'produto_cultura', text: 'Neste produto e cultura' },
  { value: 'relacao', text: 'Nesta relação de produto, cultura e alvo' },
]
const defaultScopes = {
  cultura: 'empresa',
  alvo: 'empresa',
  tipo_aplicacao: 'empresa',
  unidade_dose: 'empresa',
  unidade_calda: 'empresa',
  local_aplicacao: 'empresa',
  estagio_cultura: 'empresa',
  estagio_alvo: 'empresa',
}
const numericFields = [
  'dose_min',
  'dose_max',
  'volume_calda_min',
  'volume_calda',
  'numero_aplicacoes_min',
  'numero_aplicacoes_max',
  'intervalo_seguranca',
]

export default {
  props: {
    scope: { type: Object, default: () => ({}) },
    culturas: Boolean,
  },
  data() {
    return {
      file: null,
      result: null,
      corrections: {},
      prepared: {},
      memories: {},
      memoryContexts: {},
      referenceCatalog: [],
      originalValues: {},
      normalizationPage: 1,
      teachingPage: 1,
      memoryScopeOptions: memoryScopes,
      loading: false,
      bulkApplying: false,
      loadingMessage: 'Processando planilha…',
      validatedSnapshot: null,
      error: '',
      search: '',
      lineFilter: '',
      productFilter: '',
      fieldFilter: '',
      stateFilter: '',
      page: 1,
      perPage: 10,
      previewPages: { dados: 1, dados_inativar: 1 },
      manual: {},
      openBulkDetails: {},
      reviewMode: 'grouped',
      bulkChoices: {},
      bulkValues: {},
      bulkOverwrite: {},
      bulkRemember: {},
      rememberBatch: false,
      bulkContexts: {},
      bulkNotice: '',
      analysisSnapshot: null,
      analysisNotice: '',
    }
  },
  computed: {
    busy() {
      return this.loading || this.bulkApplying
    },
    issueIndex() {
      return new Map(this.issues.map((issue) => [this.key(issue), issue]))
    },
    lineIndex() {
      return new Map(
        ((this.result && this.result.linhas) || []).map((row) => [
          row.linha,
          row,
        ])
      )
    },
    referenceIndex() {
      const index = new Map()
      ;[
        ...this.referenceCatalog,
        ...((this.result && this.result.referencias) || []),
      ].forEach((ref) => {
        index.set(ref.campo, ref)
        index.set(ref.campoId, ref)
      })
      return index
    },
    productIndex() {
      return new Map(
        ((this.reference({ campo: 'produto' }) || {}).opcoes || []).map(
          (option) => [Number(option.id), option]
        )
      )
    },
    allBulkGroups() {
      return this.groupIssues(this.itemIssues)
    },
    queuedGroups() {
      return this.allBulkGroups.filter(
        (group) => this.bulkSelection(group) && this.bulkTargets(group).length
      )
    },
    queuedHasLearning() {
      return this.queuedGroups.some((group) => this.isMemoryField(group.campo))
    },
    queuedLineCount() {
      return new Set(
        this.queuedGroups.reduce(
          (rows, group) =>
            rows.concat(this.bulkTargets(group).map((issue) => issue.linha)),
          []
        )
      ).size
    },
    learningRequestCount() {
      return this.correctionPayload.reduce(
        (count, row) => count + (row.memorizar || []).length,
        0
      )
    },
    missingLearningPreview() {
      return Boolean(
        this.result &&
          !this.completed &&
          this.result.pode_confirmar === true &&
          this.analysisSnapshot === this.snapshot &&
          this.learningRequestCount &&
          !(this.result.ensinamentos || []).length
      )
    },
    preparedLearningEntries() {
      const entries = []
      Object.keys(this.corrections).forEach((line) =>
        memoryFields.forEach((campo) => {
          const entry = { linha: Number(line), campo }
          if (
            this.corrections[line][campo] != null &&
            !this.remembered(entry) &&
            this.memoryDestination(entry)
          )
            entries.push(entry)
        })
      )
      return entries
    },
    backendErrors() {
      const result = this.result || {}
      const messages = []
      ;[result.erros, result.falhas].forEach((values) => {
        ;(Array.isArray(values) ? values : values ? [values] : []).forEach(
          (value) => {
            if (typeof value === 'string') messages.push(value)
            else if (value) {
              const context = [
                value.linha != null ? `Linha ${value.linha}` : '',
                value.campo ? this.label(value.campo) : '',
              ]
                .filter(Boolean)
                .join(' · ')
              messages.push(
                [
                  context,
                  value.mensagem ||
                    value.message ||
                    value.erro ||
                    value.error ||
                    this.display(value),
                ]
                  .filter(Boolean)
                  .join(': ')
              )
            }
          }
        )
      })
      return [...new Set(messages)]
    },
    memoryIssues() {
      return this.issues.filter((issue) => issue.campo === 'memorizar')
    },
    itemIssues() {
      return this.issues.filter((issue) => issue.campo !== 'memorizar')
    },
    memoryIssueGroups() {
      const groups = new Map()
      this.memoryIssues.forEach((issue) => {
        const message =
          issue.mensagem || 'O backend não aceitou o pedido de aprendizado.'
        if (!groups.has(message))
          groups.set(message, { message, issues: [], lines: new Set() })
        const group = groups.get(message)
        group.issues.push(issue)
        group.lines.add(issue.linha)
      })
      return Array.from(groups.values())
    },
    hiddenIssueCount() {
      return (
        this.itemIssues.length -
        this.filteredGroups.reduce(
          (count, group) => count + group.issues.length,
          0
        )
      )
    },
    confirmationBlockReason() {
      if (!this.result || this.completed || this.canConfirm) return ''
      if (this.analysisSnapshot !== this.snapshot)
        return 'Há ajustes ou parâmetros ainda não revalidados. Clique em “Revalidar ajustes”.'
      if (this.missingLearningPreview)
        return 'Os itens foram validados, mas o backend não preparou nenhuma equivalência para os pedidos de aprendizado. Confira o diagnóstico do aprendizado antes de confirmar.'
      if (this.memoryIssues.length && !this.itemIssues.length)
        return 'Os campos dos itens não têm pendências nesta análise. A confirmação está bloqueada pelos pedidos de aprendizado. Resolva o motivo indicado ou mantenha as correções sem memorizar e revalide.'
      if (this.issues.length)
        return `A confirmação está bloqueada: o backend ainda retornou ${
          this.issues.length
        } pendência(s) em ${
          new Set(this.issues.map((issue) => issue.linha)).size
        } linha(s). Revise os problemas abaixo e revalide novamente.`
      if (this.backendErrors.length)
        return 'A confirmação está bloqueada pelos erros retornados pelo backend. Confira as mensagens abaixo antes de revalidar.'
      if (this.result.pode_confirmar !== true)
        return 'O backend ainda não autorizou a confirmação desta importação. Confira os erros e as referências do produto antes de revalidar.'
      return 'Revalide os ajustes para habilitar a confirmação.'
    },
    learningAvailabilityPending() {
      return Boolean(
        this.result &&
          (this.result.aprendizado_status == null ||
            this.result.aprendizado_status === '' ||
            this.result.aprendizado_status === 'sem_escopo_empresa')
      )
    },
    learningAvailable() {
      return Boolean(
        this.result &&
          (this.result.aprendizado_status === 'disponivel' ||
            this.learningAvailabilityPending)
      )
    },
    learningMessage() {
      if (
        this.result &&
        this.result.aprendizado_status === 'sem_escopo_empresa'
      )
        return 'A API ainda não identificou a empresa logada para o aprendizado. A versão atualizada do backend deve obter essa informação do token autenticado. Entre novamente no sistema e revalide após a atualização da API. Seus ajustes continuam preservados; nenhuma equivalência foi salva.'
      if (this.learningAvailabilityPending)
        return 'O servidor ainda não informou a disponibilidade do aprendizado. Você pode marcar suas escolhas e revalidar para enviá-las à análise. Elas só serão lembradas após a confirmação pelo servidor.'
      return 'O aprendizado ainda não está disponível.'
    },
    normalizations() {
      return ((this.result && this.result.normalizacoes) || []).map((item) => ({
        ...item,
        valor_recebido: Object.prototype.hasOwnProperty.call(
          item,
          'valor_recebido'
        )
          ? item.valor_recebido
          : item.valor_original !== undefined
          ? item.valor_original
          : item.valor,
      }))
    },
    teachingGroups() {
      const groups = new Map()
      const add = (entry) => {
        if (!memoryFields.includes(entry.campo)) return
        if (!groups.has(entry.linha))
          groups.set(entry.linha, { linha: entry.linha, entries: new Map() })
        groups.get(entry.linha).entries.set(entry.campo, entry)
      }
      this.normalizations.forEach((item) =>
        add({ ...item, valor: item.valor_recebido })
      )
      Object.keys(this.corrections).forEach((line) => {
        memoryFields.forEach((campo) => {
          if (this.corrections[line][campo] == null) return
          const linha = Number(line)
          const existing =
            groups.get(linha) && groups.get(linha).entries.get(campo)
          const pending = this.issueIndex.get(this.key({ linha, campo }))
          add({
            ...(existing || {}),
            linha,
            campo,
            valor: existing
              ? existing.valor
              : pending
              ? pending.valor
              : this.originalValues[this.key({ linha, campo })],
          })
        })
      })
      return Array.from(groups.values()).map((group) => ({
        linha: group.linha,
        entries: Array.from(group.entries.values()),
      }))
    },
    correctionPayload() {
      return Object.keys(this.corrections).map((line) => {
        const row = { linha: Number(line), campos: this.corrections[line] }
        const marked = (this.memories[line] || []).filter((field) =>
          memoryFields.includes(field)
        )
        if (marked.length) {
          row.memorizar = marked
          if (
            marked.every(
              (campo) =>
                !this.missingOriginal({
                  valor: this.memoryOriginal(Number(line), campo),
                })
            )
          )
            row.escopo_memoria = 'empresa'
          else if (this.memoryContexts[line])
            row.escopo_memoria = this.memoryContexts[line]
        }
        return row
      })
    },
    issues() {
      return (this.result && this.result.pendencias) || []
    },
    completed() {
      return Boolean(
        this.result &&
          this.result.status === 'importado' &&
          this.result.gravado === true &&
          !this.issues.length
      )
    },
    snapshot() {
      return JSON.stringify({
        scope: this.scope,
        corrections: this.corrections,
        memories: this.memories,
        memoryContexts: this.memoryContexts,
      })
    },
    canConfirm() {
      return Boolean(
        this.file &&
          !this.busy &&
          !this.completed &&
          this.result &&
          this.result.pode_confirmar === true &&
          this.result.gravado !== true &&
          !this.issues.length &&
          !this.missingLearningPreview &&
          this.validatedSnapshot === this.snapshot
      )
    },
    validScope() {
      return (
        !this.culturas || Boolean(this.scope.id_produto && this.scope.culturas)
      )
    },
    summary() {
      const data = this.result || {}
      return [
        ['Linhas processadas', data.total_linhas_processadas],
        [
          'Linhas com pendências',
          new Set(this.issues.map((item) => item.linha)).size,
        ],
        ['Quantidade de pendências', this.issues.length],
        ['Pendências nos itens', this.itemIssues.length],
        ['Pendências de aprendizado', this.memoryIssues.length],
        ['Inclusões previstas', data.inclusoes],
        ['Alterações previstas', data.alteracoes],
        ['Inativações previstas', data.inativacoes],
      ]
    },
    statusMessage() {
      if (
        this.issues.length ||
        (this.result && this.result.status === 'revisao_necessaria')
      )
        return 'A planilha precisa de revisão. Nenhum item foi salvo.'
      if (this.completed) {
        const count = Number(this.result.aprendizados_gravados || 0)
        return count > 0
          ? `Importação concluída. ${count} ${
              count === 1
                ? 'equivalência foi lembrada'
                : 'equivalências foram lembradas'
            }.`
          : 'Importação concluída.'
      }
      if (this.result && this.result.status === 'validado')
        return 'Planilha validada. Revise as alterações antes de confirmar.'
      return 'Confira o resultado do processamento. A importação ainda não foi confirmada.'
    },
    aiUnavailable() {
      return (
        this.result &&
        this.result.ia_status &&
        /indispon|erro|falh|unavailable|error|failed|disabled|desativ|timeout/i.test(
          this.result.ia_status
        )
      )
    },
    fieldOptions() {
      return [...new Set(this.itemIssues.map((item) => item.campo))].map(
        (value) => ({ value, text: this.label(value) })
      )
    },
    filteredGroups() {
      const groups = new Map()
      this.itemIssues.forEach((issue, index) => {
        const context = this.fields(issue.linha)
        const product = this.display(context.produto || context.nome_produto)
        const prepared = this.isPrepared(issue)
        const text = JSON.stringify({ issue, context }).toLocaleLowerCase(
          'pt-BR'
        )
        if (this.lineFilter && String(issue.linha) !== String(this.lineFilter))
          return
        if (
          this.productFilter &&
          !product
            .toLocaleLowerCase('pt-BR')
            .includes(this.productFilter.toLocaleLowerCase('pt-BR'))
        )
          return
        if (this.fieldFilter && issue.campo !== this.fieldFilter) return
        if (this.stateFilter && prepared !== (this.stateFilter === 'prepared'))
          return
        if (
          this.search &&
          !text.includes(this.search.toLocaleLowerCase('pt-BR'))
        )
          return
        if (!groups.has(issue.linha))
          groups.set(issue.linha, { linha: issue.linha, context, issues: [] })
        groups.get(issue.linha).issues.push({ ...issue, key: index })
      })
      return Array.from(groups.values())
    },
    bulkGroups() {
      return this.groupIssues(
        this.filteredGroups.reduce(
          (issues, row) => issues.concat(row.issues),
          []
        )
      )
    },
    pagedBulkGroups() {
      return this.bulkGroups.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      )
    },
    pagedGroups() {
      return this.filteredGroups.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      )
    },
  },
  watch: {
    result(value) {
      if (!value) return
      const catalog = new Map(
        this.referenceCatalog.map((ref) => [ref.campo, ref])
      )
      ;(value.referencias || []).forEach((ref) => catalog.set(ref.campo, ref))
      this.referenceCatalog = Array.from(catalog.values())
      ;[
        ...(value.pendencias || []),
        ...this.normalizations.map((item) => ({
          ...item,
          valor: item.valor_recebido,
        })),
      ].forEach((item) => {
        const key = this.key(item)
        if (!Object.prototype.hasOwnProperty.call(this.originalValues, key))
          this.$set(this.originalValues, key, item.valor)
      })
    },
    file() {
      this.result = null
      this.corrections = {}
      this.memories = {}
      this.memoryContexts = {}
      this.referenceCatalog = []
      this.originalValues = {}
      this.normalizationPage = 1
      this.teachingPage = 1
      this.prepared = {}
      this.manual = {}
      this.openBulkDetails = {}
      this.reviewMode = 'grouped'
      this.bulkChoices = {}
      this.bulkValues = {}
      this.bulkOverwrite = {}
      this.bulkRemember = {}
      this.rememberBatch = false
      this.bulkContexts = {}
      this.bulkNotice = ''
      this.analysisSnapshot = null
      this.analysisNotice = ''
      this.validatedSnapshot = null
      this.error = ''
    },
    scope: {
      deep: true,
      handler(value, previous) {
        if (JSON.stringify(value) !== JSON.stringify(previous))
          this.validatedSnapshot = null
      },
    },
    filteredGroups() {
      this.page = 1
    },
  },
  methods: {
    async rememberPreparedAndRevalidate() {
      if (
        this.busy ||
        this.completed ||
        !this.learningAvailable ||
        !this.file ||
        !this.validScope
      )
        return
      const entries = this.preparedLearningEntries
      if (!entries.length) return
      this.bulkApplying = true
      this.loadingMessage = `Preparando ${
        entries.length
      } pedido(s) de aprendizado…`
      this.$emit('loading', true)
      try {
        await this.yieldReviewPaint()
        for (let index = 0; index < entries.length; index++) {
          this.setRemember(entries[index], true)
          if ((index + 1) % 100 === 0) await this.yieldReviewPaint()
        }
      } finally {
        this.bulkApplying = false
        this.$emit('loading', false)
      }
      await this.submit(false)
    },
    async continueWithoutLearning() {
      if (this.busy || this.completed || !this.file || !this.validScope) return
      this.memories = {}
      this.bulkRemember = {}
      this.validatedSnapshot = null
      await this.submit(false)
    },
    clearReviewFilters() {
      this.search = ''
      this.lineFilter = ''
      this.productFilter = ''
      this.fieldFilter = ''
      this.stateFilter = ''
      this.page = 1
    },
    acceptAnalysis(payload, snapshot) {
      this.result = payload
      this.prepared = {}
      this.bulkNotice = ''
      this.analysisSnapshot = snapshot
      // Prepared marks belong to the previous local edits, not the new API review.
      this.stateFilter = ''
      this.page = 1
      this.analysisNotice = this.completed
        ? ''
        : this.issues.length
        ? `Análise concluída: ${
            this.issues.length
          } pendência(s) ainda precisam de revisão. Os ajustes enviados foram preservados. O filtro de estado voltou para “Todos”.`
        : this.result.pode_confirmar === true
        ? 'Análise concluída. O backend autorizou a confirmação da importação.'
        : 'Análise concluída, mas o backend ainda não autorizou a confirmação. Confira os erros retornados.'
    },
    groupIssues(issues) {
      const groups = new Map()
      issues.forEach((issue) => {
        const company = this.unitCompany(issue)
        const parts = [issue.campo, typeof issue.valor, issue.valor]
        if (company) parts.push(company)
        const key = JSON.stringify(parts)
        if (!groups.has(key))
          groups.set(key, {
            key,
            campo: issue.campo,
            valor: issue.valor,
            empresa: company,
            issues: [],
            lines: new Set(),
          })
        const group = groups.get(key)
        if (!group.lines.has(issue.linha)) {
          group.lines.add(issue.linha)
          group.issues.push(issue)
        }
      })
      return Array.from(groups.values())
        .map((group) => ({
          ...group,
          messages: Array.from(
            new Set(group.issues.map((issue) => issue.mensagem).filter(Boolean))
          ),
          prepared: group.issues.filter((issue) =>
            this.bulkHasAdjustment(issue)
          ).length,
        }))
        .sort((a, b) => b.issues.length - a.issues.length)
    },
    unitCompany(issue) {
      if (!['unidade_dose', 'unidade_calda'].includes(issue.campo)) return null
      const ref = this.reference(issue)
      if (ref && ref.escopo_catalogo === 'geral') return null
      const catalogCompany = Number(ref && ref.id_empresa_sistema)
      if (Number.isSafeInteger(catalogCompany) && catalogCompany > 0)
        return catalogCompany
      const sessionCompany = Number(
        this.result &&
          this.result.empresa_aprendizado &&
          this.result.empresa_aprendizado.id_empresa_sistema
      )
      if (Number.isSafeInteger(sessionCompany) && sessionCompany > 0)
        return sessionCompany
      if (issue.empresa) return issue.empresa
      const fields = this.fields(issue.linha)
      const product = this.productIndex.get(Number(fields.id_produto))
      const company = Number(
        product && product.detalhes && product.detalhes.id_empresa_sistema
      )
      return Number.isSafeInteger(company) && company > 0 ? company : null
    },
    optionsFor(issue) {
      const ref = this.reference(issue)
      const options = (ref && ref.opcoes) || []
      if (ref && ref.escopo_catalogo === 'geral') return options
      const company = this.unitCompany(issue)
      return company &&
        options.some(
          (option) =>
            option.detalhes && option.detalhes.id_empresa_sistema != null
        )
        ? options.filter(
            (option) =>
              Number(option.detalhes && option.detalhes.id_empresa_sistema) ===
              company
          )
        : options
    },
    async yieldReviewPaint() {
      await this.$nextTick()
      await new Promise((resolve) => {
        if (typeof requestAnimationFrame === 'function')
          requestAnimationFrame(() => requestAnimationFrame(resolve))
        else setTimeout(resolve, 0)
      })
    },
    async applyQueuedAndRevalidate() {
      if (this.busy || this.completed || !this.queuedGroups.length) return
      await this.applyBulkGroups(this.queuedGroups, this.rememberBatch)
      await this.submit(false)
    },
    isMemoryField(field) {
      return memoryFields.includes(field)
    },
    bulkHasAdjustment(issue) {
      const fields = this.corrections[issue.linha] || {}
      const ref = this.reference(issue)
      return (
        Object.prototype.hasOwnProperty.call(fields, issue.campo) ||
        Boolean(
          ref && Object.prototype.hasOwnProperty.call(fields, ref.campoId)
        )
      )
    },
    bulkTargets(group) {
      return group.issues.filter(
        (issue) =>
          this.bulkOverwrite[group.key] || !this.bulkHasAdjustment(issue)
      )
    },
    numericRule(issue) {
      if (issue.campo.startsWith('dose_')) return { places: 3 }
      if (issue.campo.startsWith('volume_calda')) return { places: 2 }
      return { places: 0 }
    },
    numericBulkValue(group) {
      const raw = this.bulkValues[group.key]
      if (raw === null || raw === undefined) return null
      const text = String(raw).trim()
      const rule = this.numericRule(group)
      const places = (text.split(/[.,]/)[1] || '').length
      const value = Number(text.replace(',', '.'))
      const limit =
        rule.places === 0
          ? 2147483647
          : 10 ** (10 - rule.places) - 10 ** -rule.places
      return /^\d+(?:[.,]\d+)?$/.test(text) &&
        Number.isFinite(value) &&
        places <= rule.places &&
        value <= limit
        ? value
        : null
    },
    bulkSelection(group) {
      if (this.reference(group)) {
        const selected = this.bulkChoices[group.key]
        const option =
          selected &&
          this.optionsFor(group).find((option) => option.id === selected.id)
        return option ? { option } : null
      }
      if (!this.numeric(group)) return null
      const value = this.numericBulkValue(group)
      return value === null ? null : { value }
    },
    async applyBulk(group) {
      return this.applyBulkGroups([group])
    },
    async applyBulkGroups(groups, rememberAll = false) {
      if (this.busy || this.completed) return
      const tasks = groups
        .map((group) => {
          const selection = this.bulkSelection(group)
          return {
            group,
            selection,
            targets: selection ? this.bulkTargets(group) : [],
          }
        })
        .filter((task) => task.targets.length)
      if (!tasks.length) return
      const total = tasks.reduce(
        (count, task) => count + task.targets.length,
        0
      )
      this.bulkApplying = true
      this.loadingMessage = `Aplicando correções em ${total} linha(s)…`
      this.$emit('loading', true)
      try {
        await this.yieldReviewPaint()
        let applied = 0
        for (const { group, selection, targets } of tasks) {
          for (const issue of targets) {
            if (selection.option) this.choose(issue, selection.option)
            else this.apply(issue, { [issue.campo]: selection.value })
            if (
              (this.bulkRemember[group.key] || rememberAll) &&
              this.isMemoryField(issue.campo) &&
              this.learningAvailable
            ) {
              if (
                Object.prototype.hasOwnProperty.call(
                  this.bulkContexts,
                  group.key
                )
              )
                this.setMemoryContext(issue.linha, this.bulkContexts[group.key])
              this.setRemember(issue, true)
            }
            applied++
            if (applied % 100 === 0 && applied < total) {
              this.loadingMessage = `Aplicando correções: ${applied} de ${total}…`
              await this.yieldReviewPaint()
            }
          }
        }
        const lineCount = new Set(
          tasks.reduce(
            (rows, task) =>
              rows.concat(task.targets.map((issue) => issue.linha)),
            []
          )
        ).size
        this.bulkNotice = `${lineCount} linha(s) receberam ajustes em ${
          tasks.length
        } grupo(s). Revalide os ajustes antes de confirmar.`
      } finally {
        this.bulkApplying = false
        this.$emit('loading', false)
      }
    },
    bulkDetails(group) {
      return group.issues.map((issue) => {
        const fields = this.fields(issue.linha)
        return {
          linha: issue.linha,
          produto: fields.produto || fields.nome_produto,
          cultura: fields.cultura || fields.nome_cultura,
          alvo: fields.alvo || fields.praga || fields.nome_praga,
          ajuste: (this.corrections[issue.linha] || {})[group.campo],
          estado: this.isPrepared(issue) ? 'Ajuste preparado' : 'Pendente',
          acao:
            this.bulkOverwrite[group.key] || !this.bulkHasAdjustment(issue)
              ? 'Aplicar destino escolhido'
              : 'Manter ajuste atual',
        }
      })
    },

    memoryOriginal(line, field) {
      const key = this.key({ linha: line, campo: field })
      if (Object.prototype.hasOwnProperty.call(this.originalValues, key))
        return this.originalValues[key]
      const issue = this.issueIndex.get(key)
      if (issue) return issue.valor
      const normalization = this.normalizations.find(
        (item) => item.linha === line && item.campo === field
      )
      return normalization && normalization.valor_recebido
    },
    remembered(entry) {
      return (this.memories[entry.linha] || []).includes(entry.campo)
    },
    memoryDestination(entry) {
      const ref = this.reference(entry)
      if (!ref) return null
      const current = this.corrections[entry.linha] || {}
      // An explicit local clearing must never fall back to a previous destination.
      if (
        Object.prototype.hasOwnProperty.call(current, ref.campoId) ||
        Object.prototype.hasOwnProperty.call(current, ref.campo)
      ) {
        return current[ref.campoId] != null &&
          current[ref.campo] != null &&
          current[ref.campo] !== ''
          ? {
              [ref.campoId]: current[ref.campoId],
              [ref.campo]: current[ref.campo],
            }
          : null
      }
      const adjustment = entry.ajustes || {}
      if (adjustment[ref.campoId] != null && adjustment[ref.campo])
        return {
          [ref.campoId]: adjustment[ref.campoId],
          [ref.campo]: adjustment[ref.campo],
        }
      const option = (ref.opcoes || []).find((option) =>
        entry.id_referencia != null
          ? String(option.id) === String(entry.id_referencia)
          : option.nome === entry.valor_normalizado
      )
      if (option) return { [ref.campoId]: option.id, [ref.campo]: option.nome }
      if (entry.id_referencia != null && entry.valor_normalizado)
        return {
          [ref.campoId]: entry.id_referencia,
          [ref.campo]: entry.valor_normalizado,
        }
      return null
    },
    setRemember(entry, checked) {
      if (
        this.loading ||
        this.completed ||
        !this.learningAvailable ||
        !memoryFields.includes(entry.campo)
      )
        return
      const selected = new Set(this.memories[entry.linha] || [])
      if (checked) {
        const destination = this.memoryDestination(entry)
        if (!destination) return
        this.apply(entry, destination)
        selected.add(entry.campo)
      } else selected.delete(entry.campo)
      this.$set(this.memories, entry.linha, Array.from(selected))
      this.validatedSnapshot = null
    },
    setMemoryContext(line, value) {
      if (
        this.loading ||
        this.completed ||
        !this.learningAvailable ||
        !memoryScopes.some((option) => option.value === value)
      )
        return
      this.$set(this.memoryContexts, line, value)
      this.validatedSnapshot = null
    },
    scopeLabel(scope) {
      const option = memoryScopes.find((option) => option.value === scope)
      return option ? option.text : this.label(scope)
    },
    defaultContext(entry) {
      return this.scopeLabel(defaultScopes[entry.campo])
    },
    missingOriginal(entry) {
      return entry.valor == null || String(entry.valor).trim() === ''
    },
    normalizationLabel(origin) {
      return (
        {
          memoria: 'Escolha lembrada',
          ia: 'Sugestão da IA',
          regra_semantica: 'Regra semântica',
        }[origin] || 'Ajuste automático'
      )
    },
    teachingContext(teaching) {
      const names = {
        id_empresa_sistema: 'Empresa',
        id_produto: 'Produto',
        id_cultura: 'Cultura',
        id_pragas: 'Alvo',
        id_praga: 'Alvo',
      }
      const context = Object.keys(teaching.contexto || {})
        .map(
          (key) => `${names[key] || this.label(key)}: ${teaching.contexto[key]}`
        )
        .join(' · ')
      return [this.scopeLabel(teaching.escopo), context]
        .filter(Boolean)
        .join(' · ')
    },
    label(field) {
      return labels[field] || String(field).replace(/_/g, ' ')
    },
    previewRows(key) {
      const values = (this.result && this.result[key]) || []
      if (!Array.isArray(values)) return [{ valor: values }]
      return values.map((value) =>
        value && typeof value === 'object' && !Array.isArray(value)
          ? value
          : { valor: value }
      )
    },
    previewFields(key) {
      return [
        ...new Set(
          this.previewRows(key).reduce(
            (keys, row) => keys.concat(Object.keys(row)),
            []
          )
        ),
      ].map((key) => ({ key, label: this.label(key) }))
    },
    display(value) {
      if (value === null || value === undefined || value === '')
        return 'Não informado'
      return typeof value === 'object'
        ? JSON.stringify(value, null, 2)
        : String(value)
    },
    fields(line) {
      const row = this.lineIndex.get(line)
      return {
        ...((row && row.campos) || {}),
        ...(this.corrections[line] || {}),
      }
    },
    reference(issue) {
      return this.referenceIndex.get(issue.campo)
    },
    filterOption(option, label, search) {
      return [option.nome, ...(option.aliases || []), option.mapa]
        .join(' ')
        .toLocaleLowerCase('pt-BR')
        .includes(search.toLocaleLowerCase('pt-BR'))
    },
    key(issue) {
      return JSON.stringify([issue.linha, issue.campo])
    },
    isPrepared(issue) {
      return Boolean(this.prepared[this.key(issue)])
    },
    apply(issue, adjustments) {
      if (
        this.loading ||
        this.completed ||
        !adjustments ||
        typeof adjustments !== 'object'
      )
        return
      this.$set(this.corrections, issue.linha, {
        ...(this.corrections[issue.linha] || {}),
        ...adjustments,
      })
      const selected = this.memories[issue.linha] || []
      this.$set(
        this.memories,
        issue.linha,
        selected.filter((campo) => {
          const ref = this.reference({ campo })
          const values = this.corrections[issue.linha]
          return (
            ref &&
            values[ref.campoId] != null &&
            values[ref.campo] != null &&
            values[ref.campo] !== ''
          )
        })
      )
      this.$set(this.prepared, this.key(issue), true)
      this.validatedSnapshot = null
    },
    approve(issue, suggestion) {
      this.apply(issue, suggestion.ajustes)
    },
    choose(issue, option) {
      const ref = this.reference(issue)
      if (!ref || !option) return
      const adjustments = { [ref.campoId]: option.id, [ref.campo]: option.nome }
      const excluded = this.fields(issue.linha).nao_aplicavel || []
      adjustments.nao_aplicavel = excluded.filter(
        (field) => field !== ref.campo
      )
      if (ref.campo === 'produto')
        adjustments.mapa_produto = option.mapa == null ? null : option.mapa
      this.apply(issue, adjustments)
    },
    hasVolume(issue) {
      const fields = this.fields(issue.linha)
      return Object.keys(fields).some(
        (key) =>
          /^volume_calda/.test(key) &&
          fields[key] !== null &&
          fields[key] !== undefined &&
          String(fields[key]).trim() !== ''
      )
    },
    canExclude(issue) {
      return (
        issue.permite_nao_aplicavel === true &&
        !(issue.campo === 'unidade_calda' && this.hasVolume(issue))
      )
    },
    exclude(issue) {
      const ref = this.reference(issue)
      if (!this.canExclude(issue) || !ref) return
      this.apply(issue, {
        [ref.campoId]: null,
        [ref.campo]: null,
        nao_aplicavel: [
          ...new Set([
            ...(this.fields(issue.linha).nao_aplicavel || []),
            ref.campo,
          ]),
        ],
      })
    },
    numeric(issue) {
      return (
        numericFields.includes(issue.campo) || typeof issue.valor === 'number'
      )
    },
    edit(issue, value) {
      if (String(value).trim() === '') {
        this.apply(issue, { [issue.campo]: null })
      } else if (Number.isFinite(Number(value))) {
        this.apply(issue, { [issue.campo]: Number(value) })
      }
    },
    chosen(issue) {
      const adjustments = this.corrections[issue.linha] || {}
      return Object.keys(adjustments)
        .map((key) => `${this.label(key)}: ${this.display(adjustments[key])}`)
        .join(' · ')
    },
    normalize(payload) {
      const data = payload && typeof payload === 'object' ? payload : {}
      const nested = data.resultado || data.result || data.dados
      return nested && !Array.isArray(nested) && typeof nested === 'object'
        ? { ...data, ...nested }
        : data
    },
    backendMessage(payload) {
      const messages = [payload.mensagem || payload.message || payload.msg]
      ;[payload.erros, payload.falhas].forEach((values) => {
        ;(Array.isArray(values) ? values : values ? [values] : []).forEach(
          (value) => {
            const message =
              typeof value === 'string'
                ? value
                : value &&
                  (value.mensagem || value.message || value.erro || value.error)
            if (message) messages.push(message)
          }
        )
      })
      return messages.filter(Boolean).join(' · ')
    },
    async submit(confirm = false) {
      if (
        this.busy ||
        this.completed ||
        !this.file ||
        !this.validScope ||
        (confirm && !this.canConfirm)
      )
        return
      this.loadingMessage = confirm
        ? 'Confirmando importação…'
        : this.result
        ? 'Revalidando ajustes…'
        : 'Analisando planilha…'
      this.loading = true
      this.$emit('loading', true)
      this.error = ''
      this.analysisNotice = ''
      this.validatedSnapshot = null
      const snapshot = this.snapshot
      try {
        const form = new FormData()
        form.append('arquivo', this.file)
        form.append('confirmar', String(confirm))
        Object.keys(this.scope).forEach((key) => {
          if (
            this.scope[key] !== '' &&
            this.scope[key] !== undefined &&
            this.scope[key] !== null
          )
            form.append(key, String(this.scope[key]))
        })
        form.append('correcoes', JSON.stringify(this.correctionPayload))
        const method = this.culturas
          ? 'importarPlanilhaCulturas'
          : 'importarPlanilha'
        const response = await Service[method](
          this.$store.state.auth.currentUser.token,
          form
        )
        this.acceptAnalysis(this.normalize(response.data), snapshot)
        if (
          this.result.pode_confirmar === true &&
          !this.issues.length &&
          snapshot === this.snapshot
        )
          this.validatedSnapshot = snapshot
        if (this.completed) this.$emit('imported')
      } catch (error) {
        const payload = this.normalize(error.response && error.response.data)
        if (payload.status || Array.isArray(payload.pendencias)) {
          this.acceptAnalysis(payload, snapshot)
        }
        this.error =
          this.backendMessage(payload) ||
          'Não foi possível processar a planilha. Seus ajustes foram preservados. Tente novamente.'
      } finally {
        this.loading = false
        this.$emit('loading', false)
      }
    },
  },
}
</script>

<template>
  <section
    class="import-review"
    aria-label="Revisão da importação"
    :aria-busy="busy ? 'true' : 'false'"
  >
    <div
      v-if="busy"
      class="review-loading-overlay"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div class="review-loading-card">
        <b-spinner variant="primary" aria-hidden="true" />
        <strong>{{ loadingMessage }}</strong>
        <span class="text-muted small"
          >Aguarde a conclusão do processamento.</span
        >
      </div>
    </div>
    <b-form-file
      v-model="file"
      :disabled="busy"
      accept=".xlsx,.xls,.csv"
      browse-text="Selecionar arquivo"
      placeholder="Nenhum arquivo selecionado"
      drop-placeholder="Solte a planilha aqui"
    />
    <b-alert v-if="error" show variant="danger" class="mt-3">{{
      error
    }}</b-alert>
    <div v-if="result" class="mt-3">
      <b-alert
        show
        :variant="completed ? 'success' : issues.length ? 'warning' : 'info'"
        >{{ statusMessage }}</b-alert
      >
      <b-alert
        v-if="analysisNotice && analysisSnapshot === snapshot"
        show
        :variant="canConfirm ? 'success' : 'info'"
        aria-live="polite"
        >{{ analysisNotice }}</b-alert
      >
      <b-alert v-if="backendErrors.length && !completed" show variant="danger">
        <strong>Erros retornados pelo backend</strong>
        <ul class="mb-0 mt-2"
          ><li
            v-for="(message, index) in backendErrors.slice(0, 10)"
            :key="index"
            >{{ message }}</li
          ></ul
        >
        <p v-if="backendErrors.length > 10" class="mb-0 mt-2"
          >Há mais {{ backendErrors.length - 10 }} erro(s). Consulte os detalhes
          em “Erros” e “Falhas”.</p
        >
      </b-alert>
      <section
        v-if="memoryIssues.length && !completed"
        class="review-learning-errors mt-3 mb-3"
        aria-label="Pendências de aprendizado"
      >
        <h5>O que está impedindo o aprendizado</h5>
        <p v-if="!itemIssues.length"
          >A análise não apontou pendências nos campos dos itens. O bloqueio
          está nos pedidos de lembrar equivalências, que são uma etapa
          separada.</p
        >
        <p v-else
          >Há {{ itemIssues.length }} pendência(s) nos campos dos itens e
          {{ memoryIssues.length }} nos pedidos de lembrar equivalências.
          Corrigir um item não significa que o backend conseguiu memorizar a
          escolha.</p
        >
        <article
          v-for="group in memoryIssueGroups"
          :key="group.message"
          class="review-line"
        >
          <strong>{{ group.message }}</strong>
          <p class="mt-2 mb-1"
            >{{ group.issues.length }} pedido(s) de aprendizado em
            {{ group.lines.size }} linha(s).</p
          >
          <details
            ><summary>Conferir linhas e valores recebidos</summary
            ><div class="review-affected-lines"
              ><b-table
                :items="group.issues"
                :fields="[
                  { key: 'linha', label: 'Linha' },
                  { key: 'valor', label: 'Valor recebido' },
                ]"
                responsive
                small
                striped
                ><template v-slot:cell(valor)="cell">{{
                  display(cell.value)
                }}</template></b-table
              ></div
            ></details
          >
        </article>
        <p
          >Para importar sem guardar equivalências para próximas planilhas,
          retire os pedidos de aprendizado. As referências e os valores que você
          corrigiu serão mantidos.</p
        >
        <b-button
          variant="outline-primary"
          :disabled="busy || !file || !validScope"
          @click="continueWithoutLearning"
          >Manter correções sem memorizar e revalidar</b-button
        >
        <p class="small text-muted mt-2 mb-0"
          >Isso ainda não importa os itens. A confirmação será liberada somente
          se o backend aprovar a nova análise.</p
        >
      </section>
      <b-alert v-if="missingLearningPreview" show variant="warning">
        <strong
          >O backend validou os itens, mas não confirmou a prévia do
          aprendizado.</strong
        >
        <p class="mt-2"
          >Foram enviados {{ learningRequestCount }} campo(s) para lembrar e
          nenhuma equivalência foi preparada. Isso exige verificar a
          versão/configuração da API; confirmar agora não garante que a memória
          seja salva.</p
        >
        <b-button
          size="sm"
          variant="outline-primary"
          :disabled="busy"
          @click="continueWithoutLearning"
          >Manter correções sem memorizar e revalidar</b-button
        >
      </b-alert>
      <b-alert
        v-if="
          result.empresa_aprendizado &&
            result.empresa_aprendizado.id_empresa_sistema &&
            !completed
        "
        show
        variant="info"
        >O aprendizado desta importação pertence à empresa logada
        {{ result.empresa_aprendizado.id_empresa_sistema }}. A gravação das
        equivalências ocorre junto com a confirmação dos itens.</b-alert
      >
      <b-alert
        v-if="
          completed &&
            learningRequestCount &&
            !Number(result.aprendizados_gravados)
        "
        show
        variant="warning"
        >Os itens foram importados, mas o servidor não informou equivalências
        gravadas. A memória não pode ser considerada salva. Verifique a
        versão/configuração da API.</b-alert
      >
      <p v-if="aiUnavailable" class="text-muted small"
        >A IA está indisponível. Continue a revisão com as opções do banco de
        dados.</p
      >
      <div class="review-summary">
        <div v-for="item in summary" :key="item[0]" class="review-metric"
          ><span>{{ item[0] }}</span
          ><strong>{{ item[1] == null ? '—' : item[1] }}</strong></div
        >
      </div>
      <details
        v-if="normalizations.length"
        class="mt-4"
        aria-label="Escolhas automáticas"
      >
        <summary class="font-weight-bold"
          >Escolhas automáticas ({{ normalizations.length }})</summary
        >
        <article
          v-for="(entry, index) in normalizations.slice(
            (normalizationPage - 1) * perPage,
            normalizationPage * perPage
          )"
          :key="index"
          class="review-line"
        >
          <b-badge variant="info">{{
            normalizationLabel(entry.origem)
          }}</b-badge>
          <p class="mt-2 mb-1"
            >Linha {{ entry.linha }} · {{ label(entry.campo) }}</p
          >
          <p
            >{{ display(entry.valor_recebido) }} →
            {{
              display(
                (corrections[entry.linha] || {})[entry.campo] !== undefined
                  ? corrections[entry.linha][entry.campo]
                  : entry.valor_normalizado
              )
            }}</p
          >
          <b-form-group v-if="reference(entry)" label="Revisar escolha">
            <v-select
              :value="null"
              :options="optionsFor(entry)"
              :filter-by="filterOption"
              label="nome"
              :disabled="busy || completed"
              :clearable="false"
              placeholder="Escolher outro destino"
              @input="choose(entry, $event)"
            />
          </b-form-group>
        </article>
        <b-pagination
          v-if="normalizations.length > perPage"
          v-model="normalizationPage"
          :total-rows="normalizations.length"
          :per-page="perPage"
          aria-label="Páginas das escolhas automáticas"
        />
      </details>
      <template v-if="itemIssues.length">
        <h5 class="mt-4">Revisar e corrigir pendências</h5>
        <div class="review-filters">
          <b-form-group label="Pesquisa"
            ><b-form-input v-model="search" placeholder="Pesquisar pendências"
          /></b-form-group>
          <b-form-group label="Linha"
            ><b-form-input v-model="lineFilter" type="number" min="1"
          /></b-form-group>
          <b-form-group label="Produto"
            ><b-form-input v-model="productFilter"
          /></b-form-group>
          <b-form-group label="Campo"
            ><b-form-select
              v-model="fieldFilter"
              :options="[{ value: '', text: 'Todos' }, ...fieldOptions]"
          /></b-form-group>
          <b-form-group label="Estado"
            ><b-form-select
              v-model="stateFilter"
              :options="[
                { value: '', text: 'Todos' },
                { value: 'pending', text: 'Pendente' },
                { value: 'prepared', text: 'Ajuste preparado' },
              ]"
          /></b-form-group>
        </div>
        <b-alert
          v-if="hiddenIssueCount > 0"
          show
          variant="warning"
          class="mt-2"
        >
          {{ hiddenIssueCount }} de {{ itemIssues.length }} pendência(s) estão
          ocultas pelos filtros atuais.
          <b-button
            size="sm"
            variant="outline-dark"
            :disabled="busy"
            @click="clearReviewFilters"
            >Mostrar todas as pendências</b-button
          >
        </b-alert>
        <div class="review-mode-bar">
          <b-form-radio-group
            v-model="reviewMode"
            buttons
            button-variant="outline-primary"
            :options="[
              { value: 'grouped', text: 'Por valor recebido' },
              { value: 'lines', text: 'Por linha' },
            ]"
            @change="page = 1"
          />
          <span class="text-muted"
            >{{ filteredGroups.length }} linha(s) ·
            {{ bulkGroups.length }} grupo(s) de pendências</span
          >
        </div>
        <div
          v-if="queuedGroups.length && !completed"
          class="review-batch-toolbar mt-3"
        >
          <strong
            >{{ queuedGroups.length }} escolha(s) pronta(s) para aplicar em
            {{ queuedLineCount }} linha(s)</strong
          >
          <p class="small text-muted mb-2"
            >Escolha os destinos em vários grupos, inclusive em outras páginas.
            O botão “Aplicar escolhas e revalidar” aplica todas essas escolhas e
            faz uma única revalidação. Nenhuma sugestão é aprovada
            automaticamente.</p
          >
          <b-form-checkbox
            v-if="queuedHasLearning"
            v-model="rememberBatch"
            :disabled="busy || !learningAvailable"
            >Lembrar as equivalências deste lote nas próximas
            importações</b-form-checkbox
          >
          <p
            v-if="
              queuedHasLearning && rememberBatch && learningAvailabilityPending
            "
            class="small text-muted mb-0 mt-1"
            >{{ learningMessage }}</p
          >
          <b-button
            class="mt-3"
            variant="primary"
            :disabled="busy || !file || !validScope"
            @click="applyQueuedAndRevalidate"
            >Aplicar {{ queuedGroups.length }} escolha(s) e revalidar</b-button
          >
        </div>
        <template v-if="reviewMode === 'grouped'">
          <p class="text-muted small mt-3"
            >Escolha um destino ou informe um valor numérico para cada grupo e
            aplique de uma vez às linhas indicadas. A ação considera todas as
            páginas dos filtros atuais. Ajustes já escolhidos são preservados, a
            menos que você marque a opção de substituí-los.</p
          >
          <b-alert v-if="bulkNotice" show variant="info" aria-live="polite">{{
            bulkNotice
          }}</b-alert>
          <p v-if="!bulkGroups.length" class="text-muted"
            >Nenhuma pendência encontrada com estes filtros.</p
          >
          <article
            v-for="group in pagedBulkGroups"
            :key="group.key"
            class="review-bulk-card"
          >
            <div class="review-bulk-header">
              <div
                ><strong>{{ label(group.campo) }}</strong
                ><small
                  v-if="
                    reference(group) &&
                      reference(group).escopo_catalogo === 'geral'
                  "
                  class="d-block text-muted"
                  >Cadastro geral de unidades</small
                ><small v-else-if="group.empresa" class="d-block text-muted"
                  >Unidades da empresa {{ group.empresa }}</small
                ><div class="review-original">{{
                  display(group.valor)
                }}</div></div
              >
              <div
                ><b-badge variant="warning"
                  >{{ group.issues.length }} linha(s)</b-badge
                ><div class="small text-muted mt-1"
                  >{{ group.prepared }} com ajuste escolhido</div
                ></div
              >
            </div>
            <p
              v-for="message in group.messages"
              :key="message"
              class="small mt-2 mb-1"
              >{{ message }}</p
            >
            <p
              v-if="group.campo === 'id_item_produto'"
              class="small text-muted mt-2"
            >
              A API identifica as relações pelos dados da planilha para definir
              inclusões, alterações e inativações. Não é necessário preencher o
              id_item_produto. Confira o motivo acima caso duas linhas estejam
              tentando alterar a mesma relação com valores diferentes.
            </p>
            <div v-if="reference(group)" class="review-bulk-editor">
              <b-form-group label="Substituir por" class="mb-0">
                <v-select
                  :value="bulkChoices[group.key] || null"
                  :options="optionsFor(group)"
                  :filter-by="filterOption"
                  label="nome"
                  :disabled="busy || completed"
                  placeholder="Pesquisar destino no cadastro"
                  @input="$set(bulkChoices, group.key, $event)"
                >
                  <template v-slot:option="option"
                    >{{ option.nome }}
                    <small
                      >{{ (option.aliases || []).join(', ') }}
                      {{ option.mapa ? ' · MAPA: ' + option.mapa : '' }}</small
                    ></template
                  >
                </v-select>
              </b-form-group>
              <b-button
                variant="primary"
                :disabled="
                  busy ||
                    completed ||
                    !bulkChoices[group.key] ||
                    !bulkTargets(group).length
                "
                @click="applyBulk(group)"
                >Aplicar em {{ bulkTargets(group).length }} linha(s)</b-button
              >
            </div>
            <div v-else-if="numeric(group)" class="review-bulk-editor">
              <b-form-group
                label="Informar valor para as linhas deste grupo"
                class="mb-0"
              >
                <b-form-input
                  type="text"
                  :inputmode="numericRule(group).places ? 'decimal' : 'numeric'"
                  :value="bulkValues[group.key]"
                  :disabled="busy || completed"
                  :state="
                    bulkValues[group.key] == null ||
                    String(bulkValues[group.key]).trim() === ''
                      ? null
                      : numericBulkValue(group) !== null
                  "
                  placeholder="Digite o valor"
                  @input="$set(bulkValues, group.key, $event)"
                />
                <small class="text-muted">{{
                  numericRule(group).places
                    ? 'Informe um número não negativo com até ' +
                      numericRule(group).places +
                      ' casas decimais.'
                    : 'Informe um número inteiro não negativo.'
                }}</small>
              </b-form-group>
              <b-button
                variant="primary"
                :disabled="
                  busy ||
                    completed ||
                    !bulkSelection(group) ||
                    !bulkTargets(group).length
                "
                @click="applyBulk(group)"
                >Aplicar em {{ bulkTargets(group).length }} linha(s)</b-button
              >
            </div>
            <p v-else class="small text-muted mt-2"
              >Corrija este campo na planilha e envie o arquivo atualizado. Use
              “Por linha” para conferir o motivo em cada linha.</p
            >
            <b-form-checkbox
              v-if="group.prepared"
              :checked="bulkOverwrite[group.key] || false"
              :disabled="busy || completed"
              class="mt-2"
              @change="$set(bulkOverwrite, group.key, $event)"
              >Substituir também os ajustes já preparados deste
              grupo</b-form-checkbox
            >
            <template v-if="reference(group) && isMemoryField(group.campo)">
              <b-form-checkbox
                :checked="bulkRemember[group.key] || false"
                :disabled="busy || completed || !learningAvailable"
                class="mt-2"
                @change="$set(bulkRemember, group.key, $event)"
                >Lembrar este ajuste nas próximas importações para as linhas
                afetadas</b-form-checkbox
              >
              <p
                v-if="group.valor != null && String(group.valor).trim() !== ''"
                class="small text-muted mt-1"
                >Esta equivalência será lembrada para qualquer produto e cultura
                da empresa logada.</p
              >
              <p
                v-if="!learningAvailable || learningAvailabilityPending"
                class="small text-muted mt-1"
                role="status"
                >{{ learningMessage }}</p
              >
              <b-form-group
                v-if="
                  bulkRemember[group.key] &&
                    (group.valor == null || String(group.valor).trim() === '')
                "
                label="Contexto para preencher valores ausentes"
                class="mt-2"
              >
                <b-form-select
                  :value="bulkContexts[group.key] || ''"
                  :options="
                    memoryScopeOptions.filter(
                      (option) => option.value !== 'empresa'
                    )
                  "
                  :disabled="busy || completed || !learningAvailable"
                  @input="$set(bulkContexts, group.key, $event)"
                />
                <small class="text-muted"
                  >O contexto escolhido vale para todos os campos lembrados de
                  cada linha. Sem alteração aqui, o contexto atual de cada linha
                  é preservado.</small
                >
                <p
                  v-if="
                    group.valor == null || String(group.valor).trim() === ''
                  "
                  class="small text-muted mt-1"
                  >Para valores não informados, escolha um contexto específico.
                  O contexto de empresa não permite lembrar preenchimentos
                  ausentes.</p
                >
              </b-form-group>
            </template>
            <details
              class="mt-2"
              @toggle="$set(openBulkDetails, group.key, $event.target.open)"
            >
              <summary
                >Conferir {{ group.issues.length }} linha(s) afetada(s) e seus
                ajustes</summary
              >
              <div class="review-affected-lines"
                ><b-table
                  :items="openBulkDetails[group.key] ? bulkDetails(group) : []"
                  :fields="[
                    { key: 'linha', label: 'Linha' },
                    { key: 'produto', label: 'Produto' },
                    { key: 'cultura', label: 'Cultura' },
                    { key: 'alvo', label: 'Alvo' },
                    { key: 'ajuste', label: 'Ajuste escolhido' },
                    { key: 'estado', label: 'Estado' },
                    { key: 'acao', label: 'Ação em lote' },
                  ]"
                  responsive
                  small
                  striped
                  ><template v-slot:cell()="cell">{{
                    display(cell.value)
                  }}</template></b-table
                ></div
              >
            </details>
          </article>
          <b-pagination
            v-if="bulkGroups.length > perPage"
            v-model="page"
            :total-rows="bulkGroups.length"
            :per-page="perPage"
            aria-label="Páginas dos grupos de pendências"
          />
        </template>
        <template v-else>
          <article
            v-for="group in pagedGroups"
            :key="group.linha"
            class="review-line"
          >
            <h6>Linha {{ group.linha }}</h6>
            <p
              >Produto:
              {{ display(group.context.produto || group.context.nome_produto) }}
              · Cultura:
              {{ display(group.context.cultura || group.context.nome_cultura) }}
              · Alvo:
              {{
                display(
                  group.context.alvo ||
                    group.context.praga ||
                    group.context.nome_praga
                )
              }}</p
            >
            <div
              v-for="issue in group.issues"
              :key="issue.key"
              class="review-issue"
            >
              <strong>{{ label(issue.campo) }}</strong>
              <b-badge
                :variant="isPrepared(issue) ? 'info' : 'warning'"
                class="ml-2"
                >{{
                  isPrepared(issue)
                    ? 'Ajuste preparado — aguardando revalidação'
                    : 'Pendente'
                }}</b-badge
              >
              <p class="mt-2 mb-1"
                >Valor recebido: {{ display(issue.valor) }}</p
              >
              <p>{{ issue.mensagem }}</p>
              <div
                v-for="(suggestion, index) in issue.sugestoes"
                :key="index"
                class="review-suggestion"
              >
                <span
                  >{{ suggestion.nome }}
                  <small class="text-muted">{{
                    suggestion.origem === 'ia'
                      ? 'Sugestão da IA'
                      : 'Sugestão por similaridade'
                  }}</small></span
                >
                <b-button
                  size="sm"
                  variant="outline-primary"
                  :disabled="busy || completed"
                  @click="approve(issue, suggestion)"
                  >Aprovar sugestão</b-button
                >
              </div>
              <template v-if="reference(issue)">
                <b-button
                  size="sm"
                  variant="link"
                  :disabled="busy || completed"
                  @click="$set(manual, key(issue), !manual[key(issue)])"
                  >Escolher outra opção</b-button
                >
                <v-select
                  v-if="manual[key(issue)]"
                  :value="null"
                  :options="optionsFor(issue)"
                  :filter-by="filterOption"
                  label="nome"
                  :disabled="busy || completed"
                  :clearable="false"
                  placeholder="Pesquisar opção do banco"
                  @input="choose(issue, $event)"
                >
                  <template v-slot:option="option"
                    >{{ option.nome }}
                    <small
                      >{{ (option.aliases || []).join(', ') }}
                      {{ option.mapa ? ' · MAPA: ' + option.mapa : '' }}</small
                    ></template
                  >
                </v-select>
                <b-button
                  v-if="canExclude(issue)"
                  size="sm"
                  variant="outline-secondary"
                  class="mt-2"
                  :disabled="busy || completed"
                  @click="exclude(issue)"
                  >Este campo não se aplica</b-button
                >
                <p
                  v-if="
                    issue.campo === 'unidade_calda' &&
                      issue.permite_nao_aplicavel &&
                      hasVolume(issue)
                  "
                  class="small text-muted"
                  >A unidade da calda é obrigatória quando há volume de calda
                  preenchido.</p
                >
              </template>
              <b-form-group
                v-else-if="numeric(issue)"
                label="Editar valor numérico"
                class="mt-2"
              >
                <b-form-input
                  type="number"
                  step="any"
                  :value="fields(issue.linha)[issue.campo]"
                  :disabled="busy || completed"
                  @input="validatedSnapshot = null"
                  @change="edit(issue, $event)"
                />
              </b-form-group>
              <p v-else class="small text-muted"
                >Sem catálogo de opções disponível para este campo. Corrija a
                planilha e envie o arquivo atualizado.</p
              >
              <p v-if="corrections[issue.linha]" class="small mt-2 mb-0"
                ><strong>Ajustes escolhidos nesta linha:</strong>
                {{ chosen(issue) }}</p
              >
            </div>
          </article>
          <b-pagination
            v-model="page"
            :total-rows="filteredGroups.length"
            :per-page="perPage"
            aria-label="Páginas das linhas com pendências"
          />
        </template>
      </template>
      <details class="mt-4" aria-label="Aprendizado de equivalências">
        <summary class="font-weight-bold">Lembrar escolhas por linha</summary>
        <p
          v-if="!learningAvailable || learningAvailabilityPending"
          class="text-muted"
          >{{ learningMessage }}</p
        >
        <p v-if="!teachingGroups.length" class="small text-muted"
          >Após aprovar uma sugestão ou escolher uma referência, você poderá
          marcar os campos que deseja lembrar.</p
        >
        <article
          v-for="group in teachingGroups.slice(
            (teachingPage - 1) * perPage,
            teachingPage * perPage
          )"
          :key="group.linha"
          class="review-line"
        >
          <h6>Linha {{ group.linha }}</h6>
          <p class="small text-muted"
            >As equivalências com valor recebido preenchido valem para todos os
            produtos e culturas da empresa logada.</p
          >
          <b-form-group
            v-if="group.entries.some((entry) => missingOriginal(entry))"
            label="Contexto para preencher valores ausentes"
          >
            <b-form-select
              :value="memoryContexts[group.linha] || ''"
              :options="
                memoryScopeOptions.filter(
                  (option) => option.value !== 'empresa'
                )
              "
              :disabled="busy || completed || !learningAvailable"
              @input="setMemoryContext(group.linha, $event)"
            />
          </b-form-group>
          <div
            v-for="entry in group.entries"
            :key="entry.campo"
            class="review-issue"
          >
            <p class="mb-1"
              ><strong>{{ label(entry.campo) }}</strong
              >: {{ display(entry.valor) }} →
              {{
                display(
                  (memoryDestination(entry) || {})[entry.campo] ||
                    entry.valor_normalizado
                )
              }}</p
            >
            <b-form-checkbox
              :checked="remembered(entry)"
              :disabled="
                busy ||
                  completed ||
                  !learningAvailable ||
                  !memoryDestination(entry)
              "
              @change="setRemember(entry, $event)"
              >Lembrar este ajuste nas próximas importações</b-form-checkbox
            >
            <p v-if="missingOriginal(entry)" class="small text-muted mt-1"
              >O valor original não foi informado. Escolha um contexto
              específico; preenchimentos ausentes não podem ser lembrados no
              contexto de empresa.</p
            >
            <p
              v-else-if="!memoryContexts[group.linha]"
              class="small text-muted mt-1"
              >Contexto automático: {{ defaultContext(entry) }}.</p
            >
            <p v-if="!memoryDestination(entry)" class="small text-muted"
              >Escolha uma referência com ID e nome para lembrar este ajuste.</p
            >
          </div>
        </article>
        <b-pagination
          v-if="teachingGroups.length > perPage"
          v-model="teachingPage"
          :total-rows="teachingGroups.length"
          :per-page="perPage"
          aria-label="Páginas dos ajustes para lembrar"
        />
        <h5
          v-if="result.ensinamentos && result.ensinamentos.length"
          class="mt-3"
          >Ajustes que serão lembrados</h5
        >
        <template v-if="result.ensinamentos && result.ensinamentos.length">
          <p v-if="!completed"
            >Estas escolhas serão lembradas após concluir a importação.</p
          >
          <p
            v-if="!completed && validatedSnapshot !== snapshot"
            class="small text-muted"
            >Prévia da última análise. Revalide para atualizar os ajustes que
            serão lembrados.</p
          >
          <b-table
            :items="result.ensinamentos"
            :fields="[
              { key: 'linha', label: 'Linha' },
              { key: 'campo', label: 'Campo' },
              { key: 'escolha', label: 'Valor recebido → valor escolhido' },
              { key: 'contexto', label: 'Contexto de aplicação' },
            ]"
            responsive
            small
            striped
          >
            <template v-slot:cell(campo)="cell">{{
              label(cell.value)
            }}</template>
            <template v-slot:cell(escolha)="cell"
              >{{ display(cell.item.valor_recebido) }} →
              {{ display(cell.item.valor_normalizado) }}</template
            >
            <template v-slot:cell(contexto)="cell">{{
              teachingContext(cell.item)
            }}</template>
          </b-table>
        </template>
      </details>
      <h5 class="mt-4">Prévia da importação</h5>
      <p class="small text-muted"
        >Confira as inclusões, alterações e inativações previstas antes de
        confirmar.</p
      >
      <details
        v-for="preview in [
          { key: 'dados', label: 'Inclusões e alterações' },
          { key: 'dados_inativar', label: 'Itens a inativar' },
        ]"
        :key="preview.key"
      >
        <summary>{{ preview.label }} — detalhes</summary>
        <b-table
          :items="previewRows(preview.key)"
          :fields="previewFields(preview.key)"
          :per-page="perPage"
          :current-page="previewPages[preview.key]"
          responsive
          small
          striped
          show-empty
          empty-text="Nenhum item nesta prévia."
        >
          <template v-slot:cell()="cell">{{ display(cell.value) }}</template>
        </b-table>
        <b-pagination
          v-if="previewRows(preview.key).length > perPage"
          v-model="previewPages[preview.key]"
          :total-rows="previewRows(preview.key).length"
          :per-page="perPage"
          :aria-label="'Páginas: ' + preview.label"
        />
      </details>
      <details v-if="result.erros && result.erros.length"
        ><summary>Erros</summary><pre>{{ display(result.erros) }}</pre></details
      >
      <details v-if="result.falhas && result.falhas.length"
        ><summary>Falhas</summary
        ><pre>{{ display(result.falhas) }}</pre></details
      >
      <b-alert
        v-if="confirmationBlockReason"
        show
        :variant="analysisSnapshot === snapshot ? 'warning' : 'info'"
        class="mt-3"
        >{{ confirmationBlockReason }}</b-alert
      >
    </div>
    <p v-if="!validScope" class="text-muted mt-3"
      >Selecione um produto e ao menos uma cultura para analisar.</p
    >
    <div
      v-if="preparedLearningEntries.length && !completed"
      class="review-batch-toolbar mt-3"
    >
      <strong
        >{{ preparedLearningEntries.length }} campo(s) corrigido(s) ainda não
        marcados para lembrar</strong
      >
      <p class="small text-muted mb-2"
        >Você pode marcar todos os ajustes de referência que já escolheu e
        revalidar de uma vez, sem abrir cada linha.</p
      >
      <b-button
        variant="outline-primary"
        :disabled="busy || !learningAvailable || !file || !validScope"
        @click="rememberPreparedAndRevalidate"
        >Lembrar {{ preparedLearningEntries.length }} campo(s) corrigido(s) e
        revalidar</b-button
      >
    </div>
    <div class="review-actions mt-3">
      <b-button
        v-if="queuedGroups.length"
        variant="primary"
        :disabled="busy || !file || !validScope"
        @click="applyQueuedAndRevalidate"
        >Aplicar {{ queuedGroups.length }} escolha(s) e revalidar</b-button
      >
      <b-button
        variant="outline-primary"
        :disabled="!file || busy || completed || !validScope"
        @click="submit(false)"
        >{{ result ? 'Revalidar ajustes' : 'Analisar planilha' }}</b-button
      >
      <b-button variant="primary" :disabled="!canConfirm" @click="submit(true)"
        >Confirmar importação</b-button
      >
    </div>
  </section>
</template>

<style scoped>
.review-batch-toolbar {
  padding: 16px;
  border: 1px solid #b8dacc;
  border-radius: 12px;
  background: #f2faf6;
}
.review-learning-errors {
  padding: 18px;
  border: 1px solid #edce86;
  border-radius: 12px;
  background: #fffaf0;
}
.review-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: wait;
}
.review-loading-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin: 20px;
  padding: 28px 36px;
  border: 1px solid #d9e9e2;
  border-radius: 16px;
  background: #fff;
  color: #0c5c4d;
  text-align: center;
  box-shadow: 0 12px 40px rgba(15, 46, 39, 0.12);
}

.review-summary,
.review-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}
.review-metric,
.review-line {
  padding: 16px;
  background: #f7fbf9;
  border: 1px solid #d9e9e2;
  border-radius: 12px;
}
.review-metric span,
.review-metric strong {
  display: block;
}
.review-metric strong {
  font-size: 22px;
  color: #0c5c4d;
}
.review-line {
  margin-bottom: 16px;
}
.review-issue {
  border-top: 1px solid #d9e9e2;
  padding: 14px 0;
}
.review-suggestion,
.review-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.review-suggestion {
  padding: 8px 0;
}
.review-actions {
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  z-index: 10;
  background: #fff;
  padding: 14px 0;
  border-top: 1px solid #d9e9e2;
}
.review-mode-bar,
.review-bulk-header,
.review-bulk-editor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.review-bulk-card {
  padding: 18px;
  border: 1px solid #d9e9e2;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 14px;
}
.review-original {
  font-size: 18px;
  color: #0c5c4d;
  overflow-wrap: anywhere;
}
.review-bulk-editor {
  margin-top: 12px;
  align-items: flex-end;
}
.review-bulk-editor .form-group {
  flex: 1;
  min-width: 220px;
}
.review-affected-lines {
  max-height: 320px;
  overflow: auto;
}
@media (max-width: 575px) {
  .review-bulk-editor .btn {
    width: 100%;
  }
}
pre {
  max-height: 340px;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: #f7fbf9;
  padding: 12px;
}
summary {
  cursor: pointer;
  padding: 8px 0;
}
</style>
